const options = {
  5: "bg-indigo-900/5",
  10: "bg-indigo-900/10",
  25: "bg-indigo-900/25",
  50: "bg-indigo-900/50",
  75: "bg-indigo-900/75",
  90: "bg-indigo-900/90",
  100: "bg-indigo-900",
};

const from = {
  5: "from-indigo-900/5",
  10: "from-indigo-900/10",
  25: "from-indigo-900/25",
  50: "from-indigo-900/50",
  75: "from-indigo-900/75",
  90: "from-indigo-900/90",
  100: "from-indigo-900",
};

export default function getBackgroundIndigo900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
